/// <reference types="./ai_search.d.mts" />
import * as $layout from "../../../../ds/ds/components/layout.mjs";
import { align, flex, gap, justify } from "../../../../ds/ds/components/layout.mjs";
import * as $icons from "../../../../ds/ds/icons.mjs";
import * as $el from "../../../../lustre/lustre/element.mjs";
import * as $model from "../../../data/model.mjs";
import * as $shared from "../../../frontend/view/copilot/shared.mjs";
import * as $s from "../../../frontend/view/styles/copilot.mjs";
import { toList } from "../../../gleam.mjs";

function body() {
  return $layout.column(
    toList([justify("center"), align("center"), gap(32), flex("1")]),
    toList([]),
    toList([
      $layout.column(
        toList([gap(24), align("center")]),
        toList([]),
        toList([
          $s.highlight_question(toList([]), toList([$icons.lightbulb_flash()])),
          $layout.column(
            toList([align("center"), gap(16)]),
            toList([]),
            toList([
              $s.ai_search_title(
                toList([]),
                toList([$el.text("Ask Steerlab a question")]),
              ),
              $s.ai_search_subtitle(
                toList([]),
                toList([
                  $el.text(
                    "Ask a question to Steerlab, to get answers about your data.",
                  ),
                ]),
              ),
            ]),
          ),
        ]),
      ),
    ]),
  );
}

export function view(model) {
  let props = $shared.props(model, "");
  return $s.card_wrapper(
    toList([]),
    toList([
      $shared.history(model, props),
      $layout.column(
        toList([flex("1")]),
        toList([]),
        toList([body(), $shared.copilot_input(model, props)]),
      ),
    ]),
  );
}
